import React, { useState, useRef, useEffect, useCallback, useMemo, } from "react";
import { Col, Row, Card, Container, Breadcrumb, Table, Badge } from 'react-bootstrap';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import "../../assets/css/kanban.css";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from 'primereact/dialog';
// import { backgroundAccent } from '@atlaskit/theme/colors';
import { OverlayPanel } from 'primereact/overlaypanel';
import { useParams, useNavigate, Link, useSearchParams } from "react-router-dom";
import { InputTextarea } from "primereact/inputtextarea";
import { Avatar } from 'primereact/avatar';
import { AvatarGroup } from 'primereact/avatargroup';
import { Tooltip } from 'primereact/tooltip';
import CustomToast from '../../components/CustomToast';
import { getSocket } from '../../context/socket'; // adjust path as needed
import axios from "axios";
import { useAuth } from '../../context/AuthContext';
import config from '../../config';
import Add_task from "./Add_task";
import { FaSkullCrossbones } from "react-icons/fa";
import { IoHandRightSharp } from "react-icons/io5";
import { CgFlagAlt } from "react-icons/cg";
import Archived_tasks from "./Archived_tasks";
import CardReviewQueue from "../../components/CardReviewQueue";
import CardTaskDialogContent from "../../components/CardTaskDialogContent";

const normalizeListName = (name) => String(name || '').toLowerCase().replace(/[\s_-]+/g, '');
const isCompletedColumn = (name) => ['completed', 'done'].includes(normalizeListName(name));
const isToDoColumn = (name) => normalizeListName(name) === 'todo';
const isInProgressColumn = (name) => ['inprogress', 'doing'].includes(normalizeListName(name));
const isInReviewColumn = (name) => ['inreview', 'review'].includes(normalizeListName(name));
const isInChangesColumn = (name) =>
    ['inchanges', 'changes', 'rework'].includes(normalizeListName(name));
const isWorkStageColumn = (name) =>
    isInProgressColumn(name) || isInReviewColumn(name) || isInChangesColumn(name);

const KanbanBoard = () => {
    const { accessToken, userId } = useAuth();
    const { board_id } = useParams(); // this gets the board_id from the URL
    const [searchParams, setSearchParams] = useSearchParams();
    const [newColumnName, setNewColumnName] = useState("");
    const [modalTask, setModalTask] = useState(null);
    const toastRef = useRef(null);
    const op = useRef(null);
    const navigate = useNavigate(); // React Router's navigate hook
    const [visible, setVisible] = useState(false);
    const [position, setPosition] = useState('top-right');
    const [activeColumnId, setActiveColumnId] = useState(null);
    const [selectedTaskId, setSelectedTaskId] = useState(null);
    const [reviewQueueTick, setReviewQueueTick] = useState(0);

    const show = (position, taskId) => {
        setPosition(position);
        setSelectedTaskId(taskId);  // <- Save taskId to state
        setVisible(true);
    };

    const showMessage = (severity, detail) => {
        const summary = severity.charAt(0).toUpperCase() + severity.slice(1);
        toastRef.current.show(severity, summary, detail);
    };

    /*----------addtask_showhide------------*/

    const [showTaskForm, setShowTaskForm] = useState(false);
    const [showArchivedTasks, setShowArchivedTasks] = useState(false);
    const [newTaskText, setNewTaskText] = useState("");
    const [selectedColumn, setSelectedColumn] = useState("");

    const currentBoardId = board_id


    /*----------------------fetching board data -----------------------*/

    const [data, setData] = useState(null); // replacing initialData
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const socket = getSocket();

    const handleBoardData = useCallback((board) => {
        console.log("🔌 Board data received:", board);

        try {
            const lists = board?.lists || [];
            const columns = {};
            const columnOrder = [];
            const tasks = {};
            let firstListId = null;

            lists
                .sort((a, b) => a.position - b.position)
                .forEach((list, index) => {
                    const columnId = String(list.list_id);

                    columns[columnId] = {
                        id: columnId,
                        title: list.name,
                        taskIds: [],
                        color: list.color_code,
                    };

                    columnOrder.push(columnId);
                    if (index === 0) firstListId = list.list_id;

                    (list.cards || [])
                        .sort((a, b) => a.position - b.position)
                        .forEach((card) => {
                            const taskId = String(card.card_id);
                            tasks[taskId] = {
                                id: taskId,
                                title: card.title,
                                description: card.description,
                                dueDate: card.due_date,
                                createdAt: card.created_date,
                                priority: card.priority,
                                missed_deadline: card.missed_deadline,
                                on_hold: card.on_hold,
                                taskType: card.task_type,
                                completedChecklistCount: card.completedChecklistCount,
                                totalChecklistCount: card.totalChecklistCount,
                                members: (card.members || []).map((member) => ({
                                    id: member.user_id,
                                    name: member.first_name + ' ' + member.last_name,
                                    email: member.email,
                                    image: member.profileImage?.image_url || null,
                                })),
                            };
                            columns[columnId].taskIds.push(taskId);
                        });
                });

            setData({
                board_id: board.board_id,
                board_name: board.board_name,
                columns,
                columnOrder,
                tasks,
            });

            if (firstListId !== null) {
                setSelectedColumn(firstListId);
            }
        } catch (err) {
            console.error("❌ Error parsing board data:", err);
            setError("Failed to parse board data.");
        } finally {
            setLoading(false);
        }
    }, []);

    const fetchBoardData = useCallback(async () => {
        if (!board_id) return;

        setLoading(true);
        setError('');

        try {
            const response = await axios.get(
                `${config.apiBASEURL}/TaskBoardRoutes/boards/${board_id}/full`,
                { headers: { Authorization: `Bearer ${accessToken}` } }
            );
            handleBoardData(response.data);
            return;
        } catch (httpErr) {
            console.warn('HTTP board fetch failed, trying socket:', httpErr?.message);
        }

        if (socket) {
            console.log('📡 Emitting fetchBoard with board_id:', board_id);
            socket.emit('fetchBoard', { board_id });
        } else {
            setError('Could not load board. Check that the backend is running.');
            setLoading(false);
        }
    }, [board_id, accessToken, socket, handleBoardData]);



    useEffect(() => {
        if (userId && board_id && accessToken) {
            setData(null);
            fetchBoardData();
        }
    }, [userId, board_id, accessToken, fetchBoardData]);

    useEffect(() => {
        if (!loading) return undefined;
        const timer = setTimeout(() => {
            setError((prev) => prev || 'Board is taking too long to load. Refresh the page.');
            setLoading(false);
        }, 15000);
        return () => clearTimeout(timer);
    }, [loading, board_id]);

    useEffect(() => {
        const cardFromUrl = searchParams.get('card');
        if (cardFromUrl && data?.columnOrder?.length) {
            setSelectedTaskId(cardFromUrl);
            setVisible(true);
            const nextParams = new URLSearchParams(searchParams);
            nextParams.delete('card');
            setSearchParams(nextParams, { replace: true });
        }
    }, [searchParams, data, setSearchParams]);


    const handleBoardError = useCallback((err) => {
        console.error("⚠️ Board error:", err);
        setError(err?.message || "Board error occurred");
        setLoading(false);
    }, []);


    const handleBoardUpdate = ({ board_id: updatedBoardId }) => {
        if (updatedBoardId === board_id) {
            console.log("🔄 Board updated, fetching new data...");
            socket.emit("fetchBoard", { board_id });
        }
    };

    useEffect(() => {
        if (!socket) return;

        const handleCardMoveError = (err) => {
            showMessage('error', err?.message || 'Could not move this task.');
            socket.emit('fetchBoard', { board_id });
        };

        // Setup listeners
        socket.on("boardData", handleBoardData);
        socket.on("boardError", handleBoardError);
        socket.on("cardMoveError", handleCardMoveError);

        return () => {
            // Cleanup listeners
            socket.off("boardData", handleBoardData);
            socket.off("boardError", handleBoardError);
            socket.off("cardMoveError", handleCardMoveError);


        };
    }, [handleBoardData, handleBoardError, board_id]);

    useEffect(() => {
        if (!socket) return;
        socket.on("triggerBoardFetch", handleBoardUpdate);

        return () => {
            // Cleanup listeners
            socket.off("triggerBoardFetch", handleBoardUpdate);


        };
    }, [handleBoardUpdate]);



    const handleColorChange = (listId, colorCode, boardId) => {
        socket.emit("updateListColor", { list_id: listId, color_code: colorCode, board_id: boardId });
        if (op.current) {
            op.current.hide(); // Close the overlay
        }
    };


    /*----------End_addtask_showhide------------*/

    const onDragEnd = (result) => {
        const { source, destination, draggableId, type } = result;
        if (!destination) return;
        const sourceColumn = data.columns[source.droppableId];
        const destinationColumn = data.columns[destination.droppableId];
        const draggedTask = data.tasks[draggableId];
        // Validation rules
        if (isToDoColumn(destinationColumn.title)) {
            showMessage('error', 'Cannot move tasks back to the "To Do" column.');
            return;
        }

        if (isCompletedColumn(sourceColumn.title)) {
            showMessage('error', 'Cannot move tasks from the "Completed" column.');
            return;
        }

        if (isCompletedColumn(destinationColumn.title)) {
            showMessage('error', 'Send the task to In Review and have a reviewer approve it before completing.');
            return;
        }

        if (draggedTask?.on_hold) {
            showMessage('error', 'Cannot move tasks that are currently on hold.');
            return;
        }

        const leavingToDo =
            isToDoColumn(sourceColumn.title) && !isToDoColumn(destinationColumn.title);
        const enteringWorkStage = isWorkStageColumn(destinationColumn.title);
        const hasAssignees = (draggedTask?.members || []).length > 0;
        if (
            source.droppableId !== destination.droppableId &&
            !hasAssignees &&
            (leavingToDo || enteringWorkStage)
        ) {
            showMessage(
                'error',
                'Assign someone to this task before moving it out of To Do or into In Progress / In Review.'
            );
            return;
        }

        if (type === "column") {
            // Handling column reordering
            const newColumnOrder = Array.from(data.columnOrder);
            newColumnOrder.splice(source.index, 1);
            newColumnOrder.splice(destination.index, 0, draggableId);

            setData({ ...data, columnOrder: newColumnOrder });
            return;
        }

        if (source.droppableId === destination.droppableId && source.index === destination.index) {
            // No movement
            return;
        }

        if (source.droppableId === destination.droppableId) {
            // Reordering tasks within the same column
            const newTaskIds = Array.from(sourceColumn.taskIds);
            newTaskIds.splice(source.index, 1);
            newTaskIds.splice(destination.index, 0, draggableId);

            const newColumn = { ...sourceColumn, taskIds: newTaskIds };

            setData({
                ...data,
                columns: {
                    ...data.columns,
                    [newColumn.id]: newColumn
                }
            });

            // Emit socket event for moving within the same column
            socket.emit("moveCard", {
                card_id: draggableId,
                new_list_id: sourceColumn.id,
                new_position: destination.index,
                board_id,
                user_id: userId // you must have userId from context or auth

            });

        } else {
            // Moving tasks between columns
            const sourceTaskIds = Array.from(sourceColumn.taskIds);
            sourceTaskIds.splice(source.index, 1);

            const destinationTaskIds = Array.from(destinationColumn.taskIds);
            destinationTaskIds.splice(destination.index, 0, draggableId);

            setData({
                ...data,
                columns: {
                    ...data.columns,
                    [sourceColumn.id]: { ...sourceColumn, taskIds: sourceTaskIds },
                    [destinationColumn.id]: { ...destinationColumn, taskIds: destinationTaskIds }
                }
            });

            // Emit socket event for moving between columns
            socket.emit("moveCard", {
                card_id: draggableId,
                new_list_id: destinationColumn.id,
                new_position: destination.index,
                board_id,
                user_id: userId // you must have userId from context or auth
            });

            if (isInReviewColumn(destinationColumn.title)) {
                show('top-right', draggableId);
            }
        }
    };

    const addColumn = () => {
        if (!newColumnName.trim()) return;
        const columnId = newColumnName.toLowerCase().replace(/\s+/g, "-");
        setData({
            ...data,
            columns: {
                ...data.columns,
                [columnId]: { id: columnId, title: newColumnName, taskIds: [] },
            },
            columnOrder: [...data.columnOrder, columnId],
        });
        setNewColumnName("");
    };


    const handleClose = () => {
        setShowTaskForm(false);
    };

    const handlearchievedtaskClose = () => {
        setShowArchivedTasks(false);
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        const options = { day: 'numeric', month: 'short' }; // e.g., "7 Apr"
        return date.toLocaleDateString('en-US', options);
    };


    const handleDialogClose = () => {
        if (!visible) return;
        setVisible(false);
        fetchBoardData(); // 👈 call your fetch function here
    };


    const getDueDateClass = (dueDate) => {
        if (!dueDate) return "";

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const due = new Date(dueDate);
        due.setHours(0, 0, 0, 0);

        const diffDays = (due - today) / (1000 * 60 * 60 * 24);

        if (diffDays < 0) {
            return "bg-danger"; // Passed
        } else if (diffDays === 0) {
            return "bg-danger"; // Today
        } else if (diffDays === 1) {
            return "bg-warning"; // Tomorrow
        } else {
            return "bg-success"; // Future
        }
    };


    const getTaskBadgeClass = (task, data) => {
        // Find the column this task belongs to
        const taskColumnId = Object.keys(data.columns).find(colId =>
            data.columns[colId].taskIds.includes(task.id)
        );

        const column = data.columns[taskColumnId];

        // If it's in 'Completed' list, force green badge
        if (column?.title === "Completed") {
            return "bg-success";
        }

        // Otherwise, use due date logic
        return getDueDateClass(task.dueDate);
    };

    const unassignedTasks = useMemo(() => {
        if (!data?.tasks || !data?.columns) return [];
        return Object.values(data.tasks).filter((task) => {
            if ((task.members || []).length > 0) return false;
            // Find column for this task
            const column = Object.values(data.columns).find((col) =>
                (col.taskIds || []).includes(String(task.id))
            );
            if (!column) return true;
            return !isCompletedColumn(column.title);
        });
    }, [data]);

    if (loading || !data?.columnOrder) {
        return (
            <Row className="body_content">
                <Col lg={12} className="p-4">
                    <p className="mb-2">{loading ? 'Loading board...' : (error || 'Board could not be loaded.')}</p>
                    {!loading && (
                        <Button
                            label="Back to Boards"
                            icon="pi pi-arrow-left"
                            className="border-0"
                            onClick={() => navigate('/Graphe/dashboard/boards_list')}
                        />
                    )}
                </Col>
            </Row>
        );
    }


    return (
        <>
            <Row className='body_content'>
                <Row className='mx-0'>
                    <Col lg={12} md={12} sm={12} className="p-0 ">
                        <Row className="py-3">
                            <Col lg={6} md={6} sm={12}>
                                <Breadcrumb>
                                    <Breadcrumb.Item onClick={() => navigate(-1)} style={{ cursor: "pointer" }}><i className="pi pi-angle-left"></i>Back</Breadcrumb.Item>
                                    <Breadcrumb.Item active>{data?.board_name}</Breadcrumb.Item>
                                </Breadcrumb>
                            </Col>
                            <Col lg={6} md={6} sm={12} className="d-flex justify-content-end">
                                <Button label="Archieved Tasks" onClick={() => setShowArchivedTasks(true)} style={{ padding: "5px 10px", cursor: "pointer" }} icon="pi pi-eye-slash" severity="danger" className="border-0" />
                            </Col>
                            <Col lg={12} md={12} sm={12} className="d-flex justify-content-end">
                                <div style={{ display: "flex", gap: "10px" }}>
                                    {/* <input
                                        type="text"
                                        placeholder="New Column Name"
                                        value={newColumnName}
                                        onChange={(e) => setNewColumnName(e.target.value)}
                                        style={{ padding: "5px" }}
                                    />
                                    <button onClick={addColumn} style={{ padding: "5px 10px", cursor: "pointer" }}>
                                        Add Column
                                    </button> */}
                                </div>

                                {/* Add Task */}

                            </Col>
                        </Row>
                        <CardReviewQueue
                            refreshKey={reviewQueueTick}
                            onOpenCard={({ cardId }) => {
                                setSelectedTaskId(String(cardId));
                                setVisible(true);
                            }}
                        />
                        {unassignedTasks.length > 0 && (
                            <div className="alert alert-warning py-2 mx-2 small">
                                <strong>
                                    {unassignedTasks.length} unassigned task
                                    {unassignedTasks.length === 1 ? '' : 's'}
                                </strong>
                                {' '}— assign someone before moving work out of To Do or into In Progress / In
                                Review.
                            </div>
                        )}
                        <Row className="boardHight">
                            <DragDropContext onDragEnd={onDragEnd}>
                                <Droppable droppableId="columns" direction="horizontal" type="column">
                                    {(provided) => (
                                        <div ref={provided.innerRef} {...provided.droppableProps} className="kanban-board">
                                            {data.columnOrder.map((columnId, index) => {
                                                const column = data.columns[columnId];
                                                return (
                                                    <div key={column.id} className="kanban-column">
                                                        {/* Column Header */}
                                                        <div
                                                            className="d-flex justify-content-between align-items-center text-white p-2"
                                                            style={{
                                                                background: column.color,
                                                                borderRadius: '6px',
                                                                fontWeight: 'bold',
                                                                textAlign: 'center'
                                                            }}
                                                        >
                                                            <h3 className="mb-0">{column.title}</h3>
                                                            <div>
                                                                <Button
                                                                    icon="pi pi-eye"
                                                                    className="p-0 border-0 text-white"
                                                                    text
                                                                />
                                                                <Button
                                                                    icon="pi pi-ellipsis-h"
                                                                    className="p-0 border-0 text-white"
                                                                    text
                                                                    onClick={(e) => {
                                                                        setActiveColumnId(column.id);
                                                                        op.current.toggle(e);
                                                                    }}
                                                                />
                                                                <OverlayPanel ref={op} className="Extralist">
                                                                    <ul className="overlay-extraList pt-3">
                                                                        <li>
                                                                            <Link to={''} onClick={(e) => {
                                                                                e.preventDefault();
                                                                                setShowTaskForm(true);
                                                                            }}>
                                                                                Add Task
                                                                            </Link>
                                                                        </li>
                                                                        <li>
                                                                            <Link to={''}>Watch</Link>
                                                                        </li>
                                                                        <li>
                                                                            <small className="border-bottom mt-3 mb-1 py-2 d-block">Change list color</small>
                                                                            <div className="kcolorBox">
                                                                                {[
                                                                                    '#559bfb',
                                                                                    '#9c27b0',
                                                                                    '#09c2de',
                                                                                    '#ff63a5',
                                                                                    '#f4bd0e',
                                                                                    '#816bff',
                                                                                    '#f44336',
                                                                                    '#ff9800',
                                                                                    '#4caf50',
                                                                                    '#465161',
                                                                                ].map((color) => (
                                                                                    <div
                                                                                        key={color}
                                                                                        className={`kcolorBox-item `}
                                                                                        title={color}
                                                                                        style={{ backgroundColor: color, cursor: 'pointer' }}
                                                                                        onClick={() => handleColorChange(activeColumnId, color, board_id)}
                                                                                    ></div>
                                                                                ))}
                                                                            </div>
                                                                        </li>

                                                                    </ul>
                                                                </OverlayPanel>
                                                            </div>
                                                        </div>

                                                        {/* Task List */}
                                                        <Droppable droppableId={column.id} type="task">
                                                            {(provided) => (
                                                                <div ref={provided.innerRef} {...provided.droppableProps} className="kanban-task-list">
                                                                    {column.taskIds.map((taskId, index) => {
                                                                        const task = data.tasks[taskId];
                                                                        return (
                                                                            <Draggable key={task.id} draggableId={task.id} index={index}>
                                                                                {(provided) => (
                                                                                    <div
                                                                                        className={`board-task 
                                                                                        ${task.missed_deadline ? "task-red example-1" : "task-green"} 
                                                                                        ${task.priority === 'Urgent' && column.title !== 'Completed' ? "example-1" : ""}`}
                                                                                        ref={provided.innerRef}
                                                                                        {...provided.draggableProps}
                                                                                        {...provided.dragHandleProps}

                                                                                        onClick={() => show('top-right', task.id)}
                                                                                    >
                                                                                        <div className="d-flex justify-content-end align-items-center mb-3">
                                                                                            <small className={
                                                                                                task.completedChecklistCount === task.totalChecklistCount && task.totalChecklistCount !== 0
                                                                                                    ? 'text-success'
                                                                                                    : task.completedChecklistCount < task.totalChecklistCount && task.totalChecklistCount !== 0
                                                                                                        ? 'text-warning'
                                                                                                        : ''
                                                                                            }>
                                                                                                <i className="pi pi-check-square" /> {task.completedChecklistCount}/{task.totalChecklistCount}
                                                                                            </small>

                                                                                            <Badge
                                                                                                className={`badge ${task.priority === "Urgent" || task.priority === "High"
                                                                                                    ? "bg-danger"
                                                                                                    : task.priority === "Medium"
                                                                                                        ? "bg-warning"
                                                                                                        : task.priority === "Low"
                                                                                                            ? "bg-info"
                                                                                                            : "bg-secondary"
                                                                                                    }`}
                                                                                            >
                                                                                                {task.priority}
                                                                                            </Badge>


                                                                                            {task.on_hold && (
                                                                                                <div className="ms-2" style={{ position: "relative" }}>
                                                                                                    <IoHandRightSharp
                                                                                                        data-pr-tooltip="Task Hold"
                                                                                                        data-pr-position="top"
                                                                                                        className="missed-deadline-icon example-1"
                                                                                                        style={{
                                                                                                            fontSize: "18px",
                                                                                                            color: "#f97316",
                                                                                                            marginRight: "auto",
                                                                                                        }}
                                                                                                    />
                                                                                                    <Tooltip target=".missed-deadline-icon" />
                                                                                                </div>
                                                                                            )}


                                                                                            {task.missed_deadline && (
                                                                                                <div className="ms-2" style={{ position: "relative" }}>
                                                                                                    <FaSkullCrossbones
                                                                                                        data-pr-tooltip="Deadline Missed"
                                                                                                        data-pr-position="top"
                                                                                                        className="missed-deadline-icon example-1"
                                                                                                        style={{
                                                                                                            fontSize: "18px",
                                                                                                            color: "#ff63a5",
                                                                                                            marginRight: "auto",
                                                                                                        }}
                                                                                                    />
                                                                                                    <Tooltip target=".missed-deadline-icon" />
                                                                                                </div>
                                                                                            )}

                                                                                            {task.priority === 'Urgent' && (
                                                                                                <div className="ms-2" style={{ position: "relative" }}>
                                                                                                    <CgFlagAlt
                                                                                                        data-pr-tooltip="Priority Task"
                                                                                                        data-pr-position="top"
                                                                                                        className="missed-deadline-icon example-1"
                                                                                                        style={{
                                                                                                            fontSize: "18px",
                                                                                                            color: "#ff63a5",
                                                                                                            marginRight: "auto",
                                                                                                        }}
                                                                                                    />
                                                                                                    <Tooltip target=".missed-deadline-icon" />
                                                                                                </div>
                                                                                            )}


                                                                                        </div>

                                                                                        <p className="mb-0"><small> <b>Task Name:</b> {task.title}</small></p>
                                                                                        <p className="mb-0 text-muted"><small> <b>Task Type:</b> {task.taskType}</small></p>

                                                                                        <div className="d-flex justify-content-between align-items-center border-top mt-2 pt-2">
                                                                                            <small
                                                                                                className={`text-white px-2 py-1 rounded badge ${getTaskBadgeClass(task, data)
                                                                                                    }`}
                                                                                                style={{ fontSize: '12px' }}
                                                                                            >
                                                                                                <i className="pi pi-calendar text-white mr-1" style={{ fontSize: '10px' }}></i>
                                                                                                {formatDate(task.createdAt)} - {formatDate(task.dueDate)}
                                                                                            </small>


                                                                                            <AvatarGroup>
                                                                                                {(task.members || []).length > 0 ? (
                                                                                                    task.members.map((member) => (
                                                                                                    <React.Fragment key={member.id}>
                                                                                                        <Tooltip target={`#avatar-${member.id}`} content={member.name} />
                                                                                                        <Avatar
                                                                                                            id={`avatar-${member.id}`}
                                                                                                            image={member.image || 'https://primefaces.org/cdn/primereact/images/avatar/xuxuefeng.png'}
                                                                                                            shape="circle"
                                                                                                            title={member.name}
                                                                                                        />
                                                                                                    </React.Fragment>
                                                                                                    ))
                                                                                                ) : (
                                                                                                    <Badge bg="warning" text="dark">
                                                                                                        Unassigned
                                                                                                    </Badge>
                                                                                                )}
                                                                                            </AvatarGroup>
                                                                                        </div>
                                                                                    </div>
                                                                                )}
                                                                            </Draggable>
                                                                        );
                                                                    })}
                                                                    {provided.placeholder}
                                                                </div>
                                                            )}
                                                        </Droppable>

                                                        {/* Add Task Button */}
                                                        {index === 0 && (
                                                            <div className="position-relative">
                                                                <Button
                                                                    label="Add Task"
                                                                    icon="pi pi-plus"
                                                                    severity="primary"
                                                                    className="border-0 bordbutton"
                                                                    onClick={() => setShowTaskForm(true)}
                                                                    text
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                            {provided.placeholder}
                                        </div>
                                    )}
                                </Droppable>
                            </DragDropContext>
                        </Row>

                        <Dialog
                            visible={visible}
                            position={position}
                            style={{ width: '1000px', margin: '0', borderRadius: '0', height: '100%' }}
                            onHide={handleDialogClose}
                            draggable={false}
                            resizable={false}
                            className="KanbanDialog"
                        >
                            {selectedTaskId && (
                                <CardTaskDialogContent
                                    cardId={selectedTaskId}
                                    boardId={board_id}
                                    onClose={handleDialogClose}
                                    onReviewAction={() => {
                                        fetchBoardData();
                                        setReviewQueueTick((t) => t + 1);
                                    }}
                                />
                            )}
                        </Dialog>

                        <Dialog
                            visible={showTaskForm}
                            position={position}
                            style={{ width: '1080px', margin: '0', borderRadius: '0', height: '100%' }}
                            onHide={() => { if (!showTaskForm) return; setShowTaskForm(false); }}
                            draggable={false}
                            resizable={false}
                            className="KanbanDialog"
                        >
                            <Add_task boardId={board_id} listId={selectedColumn} onClose={handleClose} />
                        </Dialog>

                        <Dialog
                            visible={showArchivedTasks}
                            position={position}
                            style={{ width: '360px', margin: '0', borderRadius: '0', height: '100%', minHeight: '99vh' }}
                            onHide={() => { if (!showArchivedTasks) return; setShowArchivedTasks(false); }}
                            draggable={false}
                            resizable={false}
                            className="KanbanDialog"
                        >
                            <Archived_tasks boardId={board_id} onClose={handlearchievedtaskClose} />
                        </Dialog>



                    </Col>
                </Row>
            </Row>
            <CustomToast ref={toastRef} />
        </>
    );
};

export default KanbanBoard;
